module.exports = __webpack_public_path__ + "static/media/LK_White_Customer Care.def7a271.svg";